import { render, staticRenderFns } from "./modal-message.vue?vue&type=template&id=072c92d4&"
import script from "./modal-message.vue?vue&type=script&lang=js&"
export * from "./modal-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports